import UserPermissionLists from './UserPermissionLists.container';

export default UserPermissionLists;
